export default __webpack_public_path__ + "static/media/product22_sportShoe.795656a0.webp";